import { inject, Injectable } from '@angular/core';
import { Router, UrlCreationOptions, UrlTree } from '@angular/router';
import { RouteProviderService } from './route-provider.service';
import { RouterLink } from '../types/router-link';
import { Nillable, valueOrUndefined } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class UrlTreeProviderService {
  private readonly provider = inject(RouteProviderService);
  private readonly router = inject(Router);

  public urlTree(
    factory: (provider: RouteProviderService) => RouterLink,
    extras: Nillable<UrlCreationOptions> = null,
  ): UrlTree {
    return this.router.createUrlTree(
      factory(this.provider),
      valueOrUndefined(extras),
    );
  }
}
